<template>
    <div class="filter__group">
        <!-- Note how this has the actual value, everything else is just
             UI sugar for this value -->
        <input :id="id"
               :name="id"
               type="hidden"
               :value="yearrange" />

        <p>
            Start year
        </p>

        <p>
            End year
        </p>

        <select v-model="start">
            <option value ref="startPlaceholder">{{ placeholder }}</option>
            <option
                v-for="year in years"
                :key="year"
                :value="year">{{ year }}</option>
        </select>

        <select v-model="end">
            <option value ref="endPlaceholder">{{ placeholder }}</option>
            <option
                v-for="year in years"
                :key="year"
                :value="year">{{ year }}</option>
        </select>
    </div>
</template>

<script>
import { ref, computed, onMounted, nextTick } from 'vue';
import { range } from 'donot';

export default {
    props: {
        id: String,
        minyear: Number,
        maxyear: Number,
        placeholder: String,
        value: [String, null]
    },

    setup(props) {
        // Reactive state
        const start = ref(null);
        const end = ref(null);
        const years = ref([]);
        const startPlaceholder = ref(null);
        const endPlaceholder = ref(null);

        // Computed property for yearrange
        const yearrange = computed(() => {
            if (end.value) {
                // If a user accidently switches around start/end
                // (so end is bigger or equal to start) or uses the
                // same year, prevent that

                if (start.value === end.value) {
                    // If both are equal, this is just a regular single year
                    return start.value;
                } else if (end.value < start.value) {
                    // Switch around start and end
                    return `${end.value}-${start.value}`;
                } else {
                    // Looks regular, proceed normally
                    return `${start.value}-${end.value}`;
                }
            } else {
                return start.value;
            }
        });

        // Methods
        const fillValues = () => {
            years.value = range(props.minyear, props.maxyear + 1);

            if (props.value) {
                // Check for a year range
                if (props.value.includes('-')) {
                    const [startValue, endValue] = props.value.split('-');
                    start.value = parseInt(startValue, 10);
                    end.value = parseInt(endValue, 10);
                } else {
                    start.value = parseInt(props.value, 10);
                }
            }
        };

        const fixPlaceholders = async () => {
            // For some reason i can't get the placeholder value to be selected
            // on an empty value, so we 'fix' it like this
            if (!start.value) {
                await nextTick();
                startPlaceholder.value.setAttribute('selected', '');
            }

            if (!end.value) {
                await nextTick();
                endPlaceholder.value.setAttribute('selected', '');
            }
        };

        // Lifecycle hooks
        onMounted(() => {
            fillValues();
            fixPlaceholders();
        });

        return {
            start,
            end,
            years,
            startPlaceholder,
            endPlaceholder,
            yearrange
        };
    }
};
</script>